<mat-card>
  <mat-card-title>{{ 'profile.data.title' | translate }}</mat-card-title>
  <mat-card-content>
    <hr>

    <router-outlet></router-outlet>

  </mat-card-content>
</mat-card>
